
import { computed, defineComponent, ref } from 'vue'
import { TreeviewNode } from '../types'

export default defineComponent({
  name: 'TreeViewSelect',
  emits: ['value-selected'],
  props: {
    placeholder: String,
    allValues: Array,
    items: Array as () => TreeviewNode[],
    selectedValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const treeViewSelect = ref<any>(null)

    const valueForSelect = computed(() => {
      if (props.selectedValue[0]) {
        const fullValue: any = props.allValues?.find((value: any) => props.selectedValue[0] === value?._id)

        if (fullValue) return fullValue.name
      }

      return undefined
    })

    function handleChange(selectedValueId: string) {
      treeViewSelect.value.isMenuActive = false
      emit('value-selected', selectedValueId)
    }

    return { emit, valueForSelect, treeViewSelect, handleChange }
  }
})
